module.exports = __webpack_public_path__ + "img/bus_traffic_light.f021ee70.svg";